import React from "react";

import Typography from "@material-ui/core/Typography";
import ReserveForm from "../../components/reserve";
import Title from "../../components/Title";
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import '../galleryStyles.scss';

export class Reserve extends React.Component {
  render() {
    return (
      <div className="container-fluid mt-5 fadeUpAn">
        <div className="row">
          <Title align="center">رزرو</Title>
            <div className="col-12">
              <Typography variant={'h6'} align={'center'} className={'text-warning'} >
                <WarningRoundedIcon />
                لطفا به ترتیب مراحل توجه کنید
              </Typography>
            </div>
          <ReserveForm />
        </div>
      </div>
    );
  }
}

export default Reserve;
